<div class="dropdown">
  <div class="dropdown-icon" (click)="openDropdown()">
    <div class="lang">
      <img
        [src]="'assets/flags/' + translationService.transformLanguageEnum(selectedLanguage)  + '_flag.png'"
        width="30"
        height="20"
      />
      <span class="header-lang">{{ languageName }}</span>
    </div>
  </div>
  <div id="change-lang" class="dropdown-content" (mouseleave)="closeDropdown()">
    <div
      [class.none]="!isShowLanguage(LanguageEnum.EnUs)"
      (click)="changeTranslation(LanguageEnum.EnUs)"
      class="lang"
      [ngClass]="{ 'lang-selected': isSelected('en-us') }"
    >
      <img src="assets/flags/en-us_flag.png" width="30" height="20"/>
      <span>EN|US</span>
    </div>
    <div
      [class.none]="!isShowLanguage(LanguageEnum.EnGb)"
      (click)="changeTranslation(LanguageEnum.EnGb)"
      class="lang"
      [ngClass]="{ 'lang-selected': isSelected('en-gb') }"
    >
      <img src="assets/flags/en-gb_flag.png" width="30" height="20"/>
      <span>EN|UK</span>
    </div>
    <div
      [class.none]="!isShowLanguage(LanguageEnum.PtBr)"
      (click)="changeTranslation(LanguageEnum.PtBr)"
      class="lang"
      [ngClass]="{ 'lang-selected': isSelected('pt-br') }"
    >
      <img src="assets/flags/pt-br_flag.png" width="30" height="20"/>
      <span>PT|BZ</span>
    </div>
    <div
      [class.none]="!isShowLanguage(LanguageEnum.FrFr)"
      (click)="changeTranslation(LanguageEnum.FrFr)"
      class="lang"
      [ngClass]="{ 'lang-selected': isSelected('fr-fr') }"
    >
      <img src="assets/flags/fr-fr_flag.png" width="30" height="20"/>
      <span>FR|FR</span>
    </div>
    <div
      [class.none]="!isShowLanguage(LanguageEnum.HeIl)"
      (click)="changeTranslation(LanguageEnum.HeIl)"
      class="lang"
      [ngClass]="{ 'lang-selected': isSelected('he-il') }"
    >
      <img src="assets/flags/he-il_flag.png" width="30" height="20"/>
      <span>HE|IL</span>
    </div>
    <div
      [class.none]="!isShowLanguage(LanguageEnum.TrTr)"
      (click)="changeTranslation(LanguageEnum.TrTr)"
      class="lang"
      [ngClass]="{ 'lang-selected': isSelected('tr-tr') }"
    >
      <img src="assets/flags/tr-tr_flag.png" width="30" height="20"/>
      <span>TR|TR</span>
    </div>
    <div
      [class.none]="!isShowLanguage(LanguageEnum.EnTst)"
      (click)="changeTranslation(LanguageEnum.EnTst)"
      class="lang"
      [ngClass]="{ 'lang-selected': isSelected('en-tst') }"
    >
      <img src="assets/flags/en-gb_flag.png" width="30" height="20"/>
      <span>EN|TST</span>
    </div>
  </div>
</div>
